import * as CubiqTS from "shared/cubiq-model-multi-asset";

export enum BfxFindFilterDateComparitor {
  TODAY,
  YESTERDAY,
  LAST_WEEK,
  LAST_MONTH,
  LAST_YEAR,
}

export namespace BfxFindFilterDateComparitor {
  export function toTimeComparison(
    value: keyof BfxFindFilterDateComparitor,
  ): CubiqTS.TimeComparison | null {
    return CubiqTS.TimeComparison.getAllElements().includes(CubiqTS.TimeComparison[value])
      ? CubiqTS.TimeComparison[value]
      : null;
  }
}
